import { useLocation } from 'react-router';

import { sharedAcrossSportsPage } from 'constants/routes';

export const useSharedAcrossSportsPage = () => {
  const location = useLocation();

  return sharedAcrossSportsPage(location.pathname);
};
